<p-menu #menu [model]="items" [popup]="true" [styleClass]="'text-sm'"></p-menu>

@if (user) {
  <app-user-info-modal [user]="user" [display]="showuserProfileModal"
  (onCancelModal)="showuserProfileModal =false"></app-user-info-modal>
  <app-admin-user-alter-privilege-modal [user]="user" [display]="showPrivilegeModal"
    [clickEvent]="user"
    (onChanceSuccess)="onRoleChangeSuccess($event)"
    (onCancelModal)="showPrivilegeModal =false">
  </app-admin-user-alter-privilege-modal>
  <app-admin-user-block-modal [user]="user" [display]="showBlockModal"
    (onSuccess)="onBlockSuccess($event)"
    (onCancelModal)="showBlockModal=false">
  </app-admin-user-block-modal>
  <app-modal [header]="'Motivo de Bloqueio'" [isShow]="showBlockReason" (cancel)="showBlockReason = false">
    {{user.sanctionReasonDescription}}
  </app-modal>
}
